import './style.scss';
import { deleteAttendance } from '../../API/apiService';

function DeleteAttendanceModal({ attendance, setOpenModalAdd, deleteRecord }) {
  const beneficiaryName = attendance?.beneficiary?.full_name || '-';
  const description =
    `\u00bfEst\u00e1s seguro de que quieres borrar la asistencia de ${beneficiaryName} permanentemente?`;

  async function deleteAttendanceRecord() {
    if (!attendance?.id) {
      return;
    }

    const response = await deleteAttendance(attendance.id);
    if (response) {
      setOpenModalAdd(false);
      deleteRecord(attendance.id);
    }
  }

  return (
    <section className='modal-info-container'>
      <button
        onClick={() => setOpenModalAdd(false)}
        className='button-close'
        type='button'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20.98'
          height='20.981'
          viewBox='0 0 20.98 20.981'
        >
          <g id='Icon-close' transform='translate(-308.562 -311.686)'>
            <path
              id='Trazado_679'
              data-name='Trazado 679'
              d='M-4680.317,593.807l16.738,16.738'
              transform='translate(4991 -280)'
              stroke='#bcbcbc'
              strokeLinecap='round'
              strokeWidth='3'
            />
            <path
              id='Trazado_680'
              data-name='Trazado 680'
              d='M-4663.579,593.807l-16.738,16.738'
              transform='translate(4991 -280)'
              fill='none'
              stroke='#bcbcbc'
              strokeLinecap='round'
              strokeWidth='3'
            />
          </g>
        </svg>
      </button>
      <div className='info-container'>
        <h2 className='title'>CONFIRMAR BORRADO</h2>
        <p className='text'>{description}</p>
        <div className='button-container'>
          <button
            className='blue-site-button but'
            onClick={deleteAttendanceRecord}
            type='button'
          >
            ELIMINAR
          </button>
          <button
            className='button-white-border-blue but'
            onClick={() => setOpenModalAdd(false)}
            type='button'
          >
            CANCELAR
          </button>
        </div>
      </div>
    </section>
  );
}

export default DeleteAttendanceModal;
